import { render } from "./TextInput.vue?vue&type=template&id=dd633606&ts=true"
import script from "./TextInput.vue?vue&type=script&lang=ts"
export * from "./TextInput.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__